var map = {
	"./Frage1_1024x768.jpg": "0b5a",
	"./Frage2_1024x768.jpg": "9098",
	"./Frage3_1024x768.jpg": "0b19",
	"./Frage4_1024x768.jpg": "a220",
	"./Frage5_1024x768.jpg": "b8fe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7fe8";